export const listingTypesMasterJson = JSON.stringify({
  configName: "listing_types_master",
  version: "1.0.0",

  form_sections: [
    {
      id: "title",
      label: "Title",
      type: "string",
      required: true,
      max_length: 100,
      ai_assist: true,
    },
    {
      id: "description",
      label: "Description",
      type: "textarea",
      required: false,
      max_length: 500,
      ai_assist: true,
    },
  ],

  shared_attributes: [
    {
      name: "condition",
      label: "Item Condition",
      type: "radio_card",
      required: true,
      listing_types: ["used_product"],
      options: [
        { value: "like_new", label: "Like New", hint: "Used once or twice" },
        { value: "good", label: "Good", hint: "Minor signs of use" },
        { value: "fair", label: "Fair", hint: "Visible wear, fully functional" },
        { value: "poor", label: "Poor", hint: "Heavy wear or issues" },
      ],
    },
    {
      name: "age",
      label: "How old is this item?",
      type: "dropdown",
      required: false,
      listing_types: ["used_product"],
      options: [
        "Less than 6 months",
        "6–12 months",
        "1–2 years",
        "2–4 years",
        "4+ years",
      ],
    },
    {
      name: "min_rental_duration",
      label: "Minimum Rental Duration",
      type: "dropdown",
      required: true,
      // NOTE: source config currently has this as [] (unlinked from any
      // listing type) — mirrored verbatim per 2026-07-24 decision to keep
      // the fallback byte-for-byte faithful to the remote config.
      listing_types: [],
      options: ["1 hour", "4 hours", "1 day", "3 days", "1 week"],
    },
    {
      name: "advance_notice",
      label: "Advance Notice Required",
      type: "dropdown",
      required: false,
      // See note on min_rental_duration above — mirrored as [] verbatim.
      listing_types: [],
      options: ["None", "1 hour", "Few hours", "1 day", "2+ days"],
    },
    {
      name: "handover_method",
      label: "Handover Method",
      type: "multi_select",
      required: true,
      // See note on min_rental_duration above — mirrored as [] verbatim.
      listing_types: [],
      options: ["Pickup Only", "I can Deliver", "Both"],
    },
    {
      name: "cuisine",
      label: "Cuisine Type",
      type: "dropdown",
      required: false,
      listing_types: ["menu"],
      options: [
        "Indian",
        "Chinese",
        "Italian",
        "Continental",
        "Street Food",
        "Desserts",
        "Beverages",
        "Other",
      ],
    },
    {
      name: "dietary_type",
      label: "Dietary",
      type: "multi_select",
      required: true,
      listing_types: ["menu"],
      options: ["Veg", "Non-Veg", "Vegan", "Jain", "Gluten-Free"],
    },
  ],

  listing_types: [
    {
      id: "new_product",
      label: "New Product",
      icon: "tag",
      description: "Sell brand new, unused items",
      badge_color: "#22C55E",
      enabled: true,
      sort_order: 1,
      required_categories: [
        "mobile_phones_tablets", "computers_laptops", "electronics",
        "vehicles", "furniture", "home_appliances", "apparel", "footwear",
        "jewelry_watches", "sporting_goods", "musical_instruments",
        "books_study_materials", "baby_kids", "pets_accessories",
        "real_estate", "others"
      ],
      category_required: true,
      media: {
        min_images: 1,
        max_images: 6,
        allow_video: true,
        ai_photo_assist: true,
      },
      pricing: {
        model: "fixed",
        label: "Price (₹)",
        negotiable_toggle: false,
        show_free_option: false,
      },
      variants: {
        enabled: true,
        default_on: false,
        axis_presets: [
          { label: "Size", options: ["S", "M", "L", "XL"] },
          { label: "Weight", options: ["250g", "500g", "1kg"] },
          { label: "Pack Size", options: ["Single", "Pack of 3", "Pack of 6"] },
          { label: "Diameter", options: ["1/2 inch", "3/4 inch", "1 inch"] },
        ],
        max_variants: 50,
        allow_custom_label: true,
      },
      cta: {
        style: "slider",
        primary_label: "Make an Offer",
        secondary_label: "Message Seller",
        guest_label: "Login to Make an Offer",
      },
    },
    {
      id: "used_product",
      label: "Used Product",
      icon: "recycle",
      description: "Give your pre-loved items a second life",
      badge_color: "#F59E0B",
      enabled: true,
      sort_order: 2,
      required_categories: [
        "mobile_phones_tablets", "computers_laptops", "electronics",
        "vehicles", "furniture", "home_appliances", "apparel", "footwear",
        "jewelry_watches", "sporting_goods", "musical_instruments",
        "books_study_materials", "baby_kids", "pets_accessories",
        "real_estate", "others"
      ],
      category_required: true,
      media: {
        min_images: 2,
        max_images: 8,
        allow_video: true,
        ai_photo_assist: true,
      },
      pricing: {
        model: "negotiable",
        label: "Asking Price (₹)",
        negotiable_toggle: true,
        show_free_option: true,
      },
      cta: {
        style: "slider",
        primary_label: "Slide to contact",
        secondary_label: "Message Seller",
        guest_label: "Login to Make an Offer",
      },
    },
    {
      id: "menu",
      label: "Menu Item",
      icon: "utensils",
      description: "List food or beverage items you offer",
      badge_color: "#EF4444",
      enabled: true,
      sort_order: 3,
      required_categories: [
        "main_course", "snacks", "beverages", "starters", "desserts", "others"
      ],
      category_required: true,
      media: {
        min_images: 1,
        max_images: 3,
        allow_video: true,
        ai_photo_assist: false,
      },
      pricing: {
        model: "fixed",
        label: "Price per serving (₹)",
        negotiable_toggle: false,
        show_free_option: false,
      },
      variants: {
        enabled: true,
        default_on: false,
        axis_presets: [
          { label: "Portion", options: ["Half", "Full"] },
          { label: "Size", options: ["Regular", "Large"] },
        ],
        max_variants: 50,
        allow_custom_label: true,
      },
      cta: {
        style: "slider",
        primary_label: "Slide to contact",
        secondary_label: "Message Seller",
        guest_label: "Login to ask a question",
      },
    },
    {
      id: "rental",
      label: "Rental",
      icon: "calendar-clock",
      description: "Rent out your items and earn",
      badge_color: "#8B5CF6",
      enabled: true,
      sort_order: 4,
      required_categories: ["paying_guest", "apartments", "others"],
      category_required: true,
      media: {
        min_images: 2,
        max_images: 6,
        allow_video: true,
        ai_photo_assist: false,
      },
      pricing: {
        // NOTE: source config has "fixed" here (not "rental_tiered") while still
        // carrying tiers/deposit — mirrored verbatim per 2026-07-24 decision.
        // StrategicDetails/SummaryCard/PricingCard currently gate the tiered
        // pricing UI on model === "rental_tiered", so as-is this will render
        // Rental as a flat price until that detection logic is updated
        // separately to key off presence of `tiers` instead.
        model: "fixed",
        tiers: [
          { id: "per_hour", label: "Per Hour", enabled: true },
          { id: "per_day", label: "Per Day", enabled: true },
          { id: "per_week", label: "Per Week", enabled: true },
          { id: "per_month", label: "Per Month", enabled: false },
        ],
        deposit_field: true,
        deposit_label: "Security Deposit (₹)",
      },
      cta: {
        style: "slider",
        primary_label: "Slide to Contact",
        secondary_label: "Message Owner",
        guest_label: "Login to ask a query",
      },
    },
    {
      id: "service",
      label: "Service",
      icon: "briefcase",
      description: "Offer your skills or professional services",
      badge_color: "#06B6D4",
      enabled: true,
      sort_order: 5,
      required_categories: [
        "home_interiors", "dance_classes", "singing_music", "gym_fitness",
        "tailoring_boutique", "sports_courts", "coaching_tuitions",
        "vehicle_services", "cooking_catering", "electronics_repair",
        "laundry_services", "clinics_labs", "others"
      ],
      category_required: true,
      media: {
        min_images: 1,
        max_images: 5,
        allow_video: true,
        ai_photo_assist: false,
      },
      pricing: {
        model: "fixed",
        label: "Starting Price (₹)",
        negotiable_toggle: true,
        show_free_option: false,
      },
      cta: {
        style: "button",
        primary_label: "Inquire Now",
        secondary_label: "Message Provider",
        guest_label: "Login to Inquire",
      },
    },
    {
      id: "real_estate",
      label: "Real Estate",
      icon: "home",
      description: "List residential, commercial, or land for sale",
      badge_color: "#06B6D4",
      enabled: true,
      sort_order: 6,
      required_categories: [
        "residential", "commercial", "land_plot", "gated_community_layouts", "others"
      ],
      category_required: true,
      media: {
        min_images: 3,
        max_images: 12,
        allow_video: true,
        ai_photo_assist: false,
      },
      pricing: {
        model: "fixed",
        label: "Price (₹)",
        negotiable_toggle: true,
        show_free_option: false,
      },
      cta: {
        // NOTE: source config has "NA" here (not a value CtaSection recognizes —
        // it only special-cases "none"). Mirrored verbatim per 2026-07-24
        // decision; as-is this will render inconsistently (guests still see a
        // CTA, logged-in users see none) until CtaSection's style handling is
        // updated separately.
        style: "NA",
        primary_label: "Contact the Sales Manager",
        secondary_label: "Message Sales Manager",
        guest_label: "Login to Contact the Sales Manager",
      },
    },
    {
      id: "info",
      label: "Info",
      icon: "info",
      description: "Share how-to content, guides, and platform tips",
      badge_color: "#3B82F6",
      enabled: true,
      sort_order: 7,
      required_categories: ["others"],
      category_required: true,
      media: {
        min_images: 0,
        max_images: 1,
        allow_video: true,
        ai_photo_assist: false,
      },
      pricing: null,
      cta: {
        // See NOTE on real_estate's cta.style above — same "NA" caveat applies.
        style: "NA",
        primary_label: "Watch Now",
        secondary_label: "Save for Later",
        guest_label: "Login to Watch",
      },
    },
  ],
});
